import repoUrls from 'src/sections/repository/urls';

import { SEARCH_VERSION_QUERY_PARAM } from '../constants';
import { NpmVersion, NugetVersion, PackageType } from '../types';
import { buildPackagesApiQueryString } from '../utils';

import { packagesResourceFactory } from './utils';

const packagesVersionResourceFactory = <ResponseType>(
  packageType: PackageType
) =>
  packagesResourceFactory<ResponseType>()({
    key: `packages-${packageType}-version`,
    pathParamNames: ['packageName', 'version'] as const,
    queryParamNames: [] as const,
    getRequestUrl: (context, pathParams, _queryParams) => {
      const queryString = buildPackagesApiQueryString({
        packageName: pathParams.packageName,
        [SEARCH_VERSION_QUERY_PARAM]: pathParams.version,
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.packageRegistryVersion(
            context.workspaceSlug,
            context.repositorySlug,
            packageType,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });

export const packagesNpmVersionResource =
  packagesVersionResourceFactory<NpmVersion>('npm');

export const packagesNugetVersionResource =
  packagesVersionResourceFactory<NugetVersion>('nuget');
